export default {
  apiUrl: process.env.VUE_APP_API_URL,
  gmapKey: process.env.VUE_APP_GMAP_KEY,
};
